import React from 'react';
import './Services.css';

const Services = () => {
  return (
    <>
      <section className="page-hero">
        <div className="container">
          <span className="eyebrow">What we offer</span>
          <h1>Our Services</h1>
          <p>Supporting the Oromo community in the UK through traditional Gadaa practices and modern services</p>
        </div>
      </section>

      <div className="services">
        <div className="container">
          <nav className="services-jump" aria-label="Service categories">
            <a href="#cultural">Cultural</a>
            <a href="#community">Community Support</a>
            <a href="#gadaa">Gadaa Practice</a>
            <a href="#social">Social</a>
            <a href="#ceremonial">Ceremonial</a>
          </nav>

          <section className="services-content">
            <div className="services-grid">

              <div className="service-category" id="cultural">
                <div className="category-head">
                  <span className="category-num">01</span>
                  <h2>Cultural Services</h2>
                </div>
                <div className="service-items">
                  <div className="service-item card">
                    <h3>Language Classes</h3>
                    <p>Afaan Oromoo (Oromo language) classes for children and adults to preserve our linguistic heritage.</p>
                    <ul>
                      <li>Weekend classes for children (ages 5-16)</li>
                      <li>Adult conversation groups</li>
                      <li>Reading and writing workshops</li>
                      <li>Cultural storytelling sessions</li>
                    </ul>
                  </div>

                  <div className="service-item card">
                    <h3>Traditional Arts & Crafts</h3>
                    <p>Workshops and classes to learn traditional Oromo arts, crafts, and cultural practices.</p>
                    <ul>
                      <li>Traditional weaving and textile arts</li>
                      <li>Pottery and craftsmanship</li>
                      <li>Traditional music and dance</li>
                      <li>Cultural artifact preservation</li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="service-category" id="community">
                <div className="category-head">
                  <span className="category-num">02</span>
                  <h2>Community Support</h2>
                </div>
                <div className="service-items">
                  <div className="service-item card">
                    <h3>Settlement Signposting</h3>
                    <p>Helping new arrivals find the right organisations and services to settle in the UK while maintaining their cultural identity and heritage.</p>
                    <ul>
                      <li>Directing individuals to local housing services and advice</li>
                      <li>Signposting to employment support and job search services</li>
                      <li>Connecting families with relevant education services and contacts</li>
                      <li>Providing guidance on GP registration and accessing NHS services</li>
                    </ul>
                  </div>

                  <div className="service-item card">
                    <h3>Legal & Administrative Referrals</h3>
                    <p>Helping individuals access appropriate legal and administrative support by directing them to qualified organisations and professional services.</p>
                    <ul>
                      <li>Referrals to qualified immigration advisers</li>
                      <li>Assistance with translation, usually provided directly by our team, with referrals to professional translation services when needed</li>
                      <li>Signposting to benefits and welfare advice services</li>
                      <li>Referrals to legal clinics and solicitors</li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="service-category" id="gadaa">
                <div className="category-head">
                  <span className="category-num">03</span>
                  <h2>Gadaa Practice Services</h2>
                </div>
                <div className="service-items">
                  <div className="service-item card">
                    <h3>Conflict Resolution</h3>
                    <p>Traditional Gadaa-based mediation and conflict resolution services for community disputes.</p>
                    <ul>
                      <li>Family dispute mediation</li>
                      <li>Community conflict resolution</li>
                      <li>Traditional reconciliation ceremonies</li>
                      <li>Restorative justice practices</li>
                    </ul>
                  </div>

                  <div className="service-item card">
                    <h3>Community Governance</h3>
                    <p>Democratic decision-making processes based on traditional Gadaa principles.</p>
                    <ul>
                      <li>Community assemblies (Gumii)</li>
                      <li>Democratic elections and leadership rotation</li>
                      <li>Consensus-building workshops</li>
                      <li>Youth leadership development</li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="service-category" id="social">
                <div className="category-head">
                  <span className="category-num">04</span>
                  <h2>Social Services</h2>
                </div>
                <div className="service-items">
                  <div className="service-item card">
                    <h3>Elder Care Support</h3>
                    <p>Respecting and caring for our elders according to Oromo traditions.</p>
                    <ul>
                      <li>Elder companionship programs</li>
                      <li>Traditional medicine knowledge sharing</li>
                      <li>Storytelling and wisdom preservation</li>
                      <li>Healthcare advocacy for elderly</li>
                    </ul>
                  </div>

                  <div className="service-item card">
                    <h3>Youth Development</h3>
                    <p>Empowering young Oromo people to succeed while staying connected to their roots.</p>
                    <ul>
                      <li>Mentorship programs</li>
                      <li>Educational scholarships</li>
                      <li>Leadership training</li>
                      <li>Cultural identity workshops</li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="service-category" id="ceremonial">
                <div className="category-head">
                  <span className="category-num">05</span>
                  <h2>Ceremonial Services</h2>
                </div>
                <div className="service-items">
                  <div className="service-item card">
                    <h3>Traditional Ceremonies</h3>
                    <p>Organizing and facilitating traditional Oromo ceremonies and celebrations.</p>
                    <ul>
                      <li>Wedding ceremonies (Fuudha)</li>
                      <li>Naming ceremonies (Maqaa baasuu)</li>
                      <li>Coming of age celebrations</li>
                      <li>Seasonal festivals</li>
                    </ul>
                  </div>

                  <div className="service-item card">
                    <h3>Spiritual Guidance</h3>
                    <p>Providing spiritual guidance and support rooted in traditional Oromo beliefs, Oromo Gadaa culture, and cultural values.</p>
                    <ul>
                      <li>Welcoming fellow Oromos and others</li>
                      <li>Coming together as a community</li>
                      <li>Sharing spiritual wisdom</li>
                      <li>Strengthening connection with Oromo spiritual traditions</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="services-contact">
            <div className="cta-band">
              <div>
                <h2>Need Our Services?</h2>
                <p>Contact us to learn more about our services or to request assistance. We're here to help our community thrive.</p>
              </div>
              <div className="cta-details">
                <p><strong>Email:</strong> oromogadaacommunity@gmail.com</p>
                <p><strong>Phone:</strong> +44 (0) 20 1234 5678</p>
                <p><strong>Office Hours:</strong> Monday - Friday, 9:00 AM - 5:00 PM</p>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default Services;
